import http from "../app/httpService";

const apiEndpoint =
  process.env.REACT_APP_USER_ACCOUNT_API + "useraccountpreferences/";

export async function getUserAccountPreferences(userAccountId) {
  const { data: userAccountPreferences } = await http.get(
    apiEndpoint + userAccountId
  );
  return userAccountPreferences;
}

export async function updateUserAccountPreferences(userAccountPreferences) {
  await http.put(apiEndpoint, userAccountPreferences);
  return userAccountPreferences;
}
